import {
    GET_CURATED_COLLECTION_SUCCESS, GET_CURATED_COLLECTION_LOADING, GET_CURATED_COLLECTION_ERROR,
    SAVE_CURATED_COLLECTION_SUCCESS, SAVE_CURATED_COLLECTION_LOADING, SAVE_CURATED_COLLECTION_ERROR
} from "../Type";
import * as Authservices from "../../Services/services";

export const getCuratedCollection = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: GET_CURATED_COLLECTION_LOADING, data: true });
        Authservices.getCuratedCollection()
            .then((res) => {
                if (res?.status >= 200 && res?.status < 300) {
                    dispatch({ type: GET_CURATED_COLLECTION_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: GET_CURATED_COLLECTION_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const saveCuratedCollection = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: SAVE_CURATED_COLLECTION_LOADING, data: true });
        Authservices.saveCuratedCollection(data)
            .then((res) => {
                if (res?.status >= 200 && res?.status < 300) {
                    dispatch({ type: SAVE_CURATED_COLLECTION_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: SAVE_CURATED_COLLECTION_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

// Search feeds a transient picker list, so it stays out of the store — the
// component owns the results and drops them when the modal closes.
export const searchCuratedCollectionSeries = (params) => () => {
    return new Promise((resolve, reject) => {
        Authservices.searchCuratedCollectionSeries(params)
            .then((res) => {
                if (res?.status >= 200 && res?.status < 300) {
                    resolve(res.data);
                }
            })
            .catch((err) => {
                reject(err?.response?.data);
            });
    });
};
